import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {},
};

export const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    clearUser: (state) => {
      return initialState;
    },
    setEditable: (state, action) => {
      state.editable = action.payload;
    },
    storeUser: (state, action) => {
      state.user = action.payload.user;
    },
    updateUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { clearUser, setEditable, storeUser, updateUser } =
  userSlice.actions;

export default userSlice.reducer;
